import {AppBar, Link, Toolbar} from "@mui/material";
import React from "react";

export const Header: React.FC = () => {

    return (
        <React.Fragment>
            <AppBar position="sticky">
                <Toolbar>
                    <Link className={'logo'}  href={'/'}><img
                        alt="A logo representing a cup of fresh Lemonade"
                        src={'/logo.png'} width={75} height={75}/></Link>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}
